import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NexyomLogo } from './NexyomLogo';
import { motion } from 'framer-motion';
export function Navigation() {
  const location = useLocation();
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.16, 1, 0.3, 1]
  }} className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-white/10" data-id="element-75">
      <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between" data-id="element-76">
        <Link to="/" className="transition-opacity hover:opacity-80 duration-300" data-id="element-77">
          <NexyomLogo variant="full" colorScheme="dark" size="sm" data-id="element-78" />
        </Link>

        <div className="flex items-center gap-10" data-id="element-79">
          <Link to="/" className={`text-sm font-medium tracking-wide transition-colors duration-300 ${location.pathname === '/' ? 'text-white' : 'text-gray-400 hover:text-white'}`} data-id="element-80">
            Accueil
          </Link>
          <Link to="/marketing-digital" className={`text-sm font-medium tracking-wide transition-colors duration-300 ${location.pathname === '/marketing-digital' ? 'text-white' : 'text-gray-400 hover:text-white'}`} data-id="element-81">
            Marketing Digital
          </Link>
          <Link to="/microsoft365" className={`text-sm font-medium tracking-wide transition-colors duration-300 ${location.pathname === '/microsoft365' ? 'text-white' : 'text-gray-400 hover:text-white'}`} data-id="element-82">
            Microsoft 365
          </Link>
          <a href="#contact" className="bg-blue-500 hover:bg-blue-600 text-white px-7 py-2.5 text-sm font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/20" data-id="element-83">
            Contact
          </a>
        </div>
      </div>
    </motion.nav>;
}